import { ComentarioOcorrencia } from '../../comum/modelos/comentario-ocorrencia';
import {Component, OnInit, Input} from '@angular/core';

@Component({
  selector: 'app-comentario-ocorrencia',
  templateUrl: './comentario-ocorrencia.component.html',
  styleUrls: ['./comentario-ocorrencia.component.css']
})
export class ComentarioOcorrenciaComponent implements OnInit {
  @Input() comentarioOcorrencia: ComentarioOcorrencia;

  constructor() {
  }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/comentario-ocorrencia/comentario-ocorrencia.component.ts